import React, { useEffect, memo, useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import CloseButton from 'react-bootstrap/CloseButton';
import PerformerStar from "../../../../styles/img/performer-chart-star.png"

const BarChart = memo((props) => {

    const [showContent, setShowContent] = useState(false);
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const [targetId, setTargetId] = useState();


    let maxSalesValue = 0;

    for (const key in props?.teamPerformance) {
        if (props?.teamPerformance[key].salesValue > maxSalesValue) {
            maxSalesValue = props?.teamPerformance[key].salesValue;
        }
    }

    const chartMaxValue = Math.ceil(maxSalesValue);
    const chartStarValue = maxSalesValue


    const totalValues = props?.teamPerformance?.brakeDisks?.salesValue +
        props?.teamPerformance?.wiperBlade?.salesValue +
        props?.teamPerformance?.brakePads?.salesValue +
        props?.teamPerformance?.battery?.salesValue


    useEffect(() => {

        let list = document.getElementById("sb-ol-list-bar-chart");
        list.innerHTML = '';

        for (let i = 0; i < maxSalesValue; ++i) {
            let li = document.createElement('li');
            list.appendChild(li);
        }

    }, [props?.teamPerformance])

    const touchStartEvent = (event) => {
        setShow(true);
        setTarget(event.target);
        setTargetId(event.target.id);
    }


    return (
        <>

            <div className='sb-bar-chart sb-bar-chart-wr sb-current-bar-chart'>
                <div className='sb-bar-chart__list'>
                    <ol id="sb-ol-list-bar-chart"></ol>
                </div>
                <div className='sb-bar-chart-horizontal'>
                    <div className='sb-bar-chart-horizontal__brake-discs'
                        id="brake-discs"
                        style={{ height: `${(props?.teamPerformance?.brakeDisks?.salesValue) * 100 / chartMaxValue}%` }}
                        onTouchStart={touchStartEvent}
                    >
                        <Overlay
                            show={show && targetId == 'brake-discs'}
                            target={target}
                            placement="top"
                            containerPadding={20}
                            onHide={() => setShow(false)}
                        >
                            <Popover id="popover-contained">
                                <Popover.Body>
                                    <CloseButton className='sb-popup-close-button' />
                                    {props.starRating && chartStarValue === props?.teamPerformance?.brakeDisks?.salesValue ? <img src={PerformerStar} /> : ''}
                                    <label id="1">£ {props?.teamPerformance?.brakeDisks?.salesValue}</label>
                                    <div className='sb-bar-chart-top-performance'>
                                        {!props.yaxisData &&
                                            <ul>
                                                <li>{props?.teamPerformance?.brakeDisks?.dealerName}</li>
                                            </ul>
                                        }
                                    </div>
                                </Popover.Body>
                            </Popover>
                        </Overlay>
                        <div className='sb-bar-chart-content-box'>
                            {props.starRating && chartStarValue === props?.teamPerformance?.brakeDisks?.salesValue ? <img src={PerformerStar} /> : ''}
                            <label id="1">£ {props?.teamPerformance?.brakeDisks?.salesValue}</label>
                            <div className='sb-bar-chart-top-performance'>
                                {!props.yaxisData &&
                                    <ul>
                                        <li>{props?.teamPerformance?.brakeDisks?.dealerName}</li>
                                    </ul>
                                }
                            </div>
                        </div>
                        <div className='sb-bar-chart-y-axis-label'>
                            {props.yaxisData ? props?.teamPerformance?.brakeDisks?.dealerName : 'Brake Discs'}
                        </div>
                    </div>


                    <div className='sb-bar-chart-horizontal__wiper-blade'
                        id="wiper-blade"
                        onTouchStart={touchStartEvent}
                        style={{ height: `${(props?.teamPerformance?.wiperBlade?.salesValue) * 100 / chartMaxValue}%` }}
                    >
                        <Overlay
                            show={show && targetId == 'wiper-blade'}
                            target={target}
                            placement="top"
                            containerPadding={20}
                        >
                            <Popover id="popover-contained">
                                <Popover.Body>
                                    <CloseButton className='sb-popup-close-button' />

                                    {props.starRating && chartStarValue === props?.teamPerformance?.wiperBlade?.salesValue ? <img src={PerformerStar} /> : ''}
                                    <label id="1">£ {props?.teamPerformance?.wiperBlade?.salesValue}</label>
                                    <div className='sb-bar-chart-top-performance'>
                                        {!props.yaxisData &&
                                            <ul>
                                                <li>{props?.teamPerformance?.wiperBlade?.dealerName}</li>
                                            </ul>
                                        }
                                    </div>
                                </Popover.Body>
                            </Popover>
                        </Overlay>
                        <div className='sb-bar-chart-content-box'>
                            {props.starRating && chartStarValue === props?.teamPerformance?.wiperBlade?.salesValue ? <img src={PerformerStar} /> : ''}
                            <label id="1">£ {props?.teamPerformance?.wiperBlade?.salesValue}</label>
                            <div className='sb-bar-chart-top-performance'>
                                {!props.yaxisData &&
                                    <ul>
                                        <li>{props?.teamPerformance?.wiperBlade?.dealerName}</li>
                                    </ul>
                                }
                            </div>
                        </div>
                        <div className='sb-bar-chart-y-axis-label'>
                            {props.yaxisData ? props?.teamPerformance?.wiperBlade?.dealerName : 'Wiper Blade'}
                        </div>
                    </div>


                    <div className='sb-bar-chart-horizontal__brake-pads'
                        id="brake-pads"
                        onTouchStart={touchStartEvent}
                        style={{ height: `${(props?.teamPerformance?.brakePads?.salesValue) * 100 / chartMaxValue}%` }}
                    >
                        <Overlay
                            show={show && targetId == 'brake-pads'}
                            target={target}
                            placement="top"
                            containerPadding={20}
                        >
                            <Popover id="popover-contained">
                                <Popover.Body>
                                    <CloseButton className='sb-popup-close-button' />
                                    {props.starRating && chartStarValue === props?.teamPerformance?.brakePads?.salesValue ? <img src={PerformerStar} /> : ''}
                                    <label id="1">£ {props?.teamPerformance?.brakePads?.salesValue}</label>
                                    <div className='sb-bar-chart-top-performance'>
                                        {!props.yaxisData &&
                                            <ul>
                                                <li>{props?.teamPerformance?.brakePads?.dealerName}</li>
                                            </ul>
                                        }
                                    </div>
                                </Popover.Body>
                            </Popover>
                        </Overlay>
                        <div className='sb-bar-chart-content-box'>
                            {props.starRating && chartStarValue === props?.teamPerformance?.brakePads?.salesValue ? <img src={PerformerStar} /> : ''}
                            <label id="1">£ {props?.teamPerformance?.brakePads?.salesValue}</label>
                            <div className='sb-bar-chart-top-performance'>
                                {!props.yaxisData &&
                                    <ul>
                                        <li>{props?.teamPerformance?.brakePads?.dealerName}</li>
                                    </ul>
                                }

                            </div>
                        </div>
                        <div className='sb-bar-chart-y-axis-label'>
                            {props.yaxisData ? props?.teamPerformance?.brakePads?.dealerName : 'Brake Pads'}
                        </div>
                    </div>

                    <div className='sb-bar-chart-horizontal__battery'
                        id="battery"
                        onTouchStart={touchStartEvent}
                        style={{ height: `${(props?.teamPerformance?.battery?.salesValue) * 100 / chartMaxValue}%` }}
                    >
                        <Overlay
                            show={show && targetId == 'battery'}
                            target={target}
                            placement="top"
                            containerPadding={20}
                        >
                            <Popover id="popover-contained">
                                <Popover.Body>
                                    <CloseButton className='sb-popup-close-button' />
                                    {props.starRating && chartStarValue === props?.teamPerformance?.battery?.salesValue ? <img src={PerformerStar} /> : ''}
                                    <label id="1">£ {props?.teamPerformance?.battery?.salesValue}</label>
                                    <div className='sb-bar-chart-top-performance'>
                                        {!props.yaxisData &&
                                            <ul>
                                                <li>{props?.teamPerformance?.battery?.dealerName}</li>
                                            </ul>
                                        }
                                    </div>
                                </Popover.Body>
                            </Popover>
                        </Overlay>
                        <div className='sb-bar-chart-content-box'>
                            {props.starRating && chartStarValue === props?.teamPerformance?.battery?.salesValue ? <img src={PerformerStar} /> : ''}
                            <label id="1">£ {props?.teamPerformance?.battery?.salesValue}</label>
                            <div className='sb-bar-chart-top-performance'>
                                {!props.yaxisData &&
                                    <ul>
                                        <li>{props?.teamPerformance?.battery?.dealerName}</li>
                                    </ul>
                                }
                            </div>
                        </div>
                        <div className='sb-bar-chart-y-axis-label'>
                            {props.yaxisData ? props?.teamPerformance?.battery?.dealerName : 'Battery'}
                        </div>
                    </div>
                </div>

            </div>



        </>
    )
}
)
export default BarChart;